import React from 'react'
import "./Sumbit_btn.css"
import { Button } from 'react-bootstrap'

function Sumbit_btn({ onClick, btnText }) {
    return (
        <>
            <Button className="Sumbit_btn" type='button' onClick={onClick}>
                {btnText}
            </Button>
        </>
    )
}

export default Sumbit_btn